import { TweenLite, TimelineLite, Expo } from 'gsap/TweenMax';

import { qsa } from '@/scripts/utils';

const addAnimation = (line) => {
  const width = line.parentNode.getBoundingClientRect().width;
  const speed = Math.min(Math.max(width / 1000, 0.4), 0.7);

  const animation = TweenLite.to(line, speed, {
    webkitClipPath: 'inset(0% 0% 0% 0%)',
    clipPath: 'inset(0% 0% 0% 0%)',
    ease: Expo.easeOut,
  });

  return animation;
};

const hover = (el) => {
  const tl = new TimelineLite({
    paused: true,
  });

  const lines = qsa('[data-line]', el);

  lines.forEach((line, index) => {
    const animation = addAnimation(line);
    tl.add(animation, (index * 0.3));
  });

  return tl;
};


export default hover;



// WEBPACK FOOTER //
// ./src/scripts/timelines/hover.js